import { readonly, reactive } from "vue";

export type ToastTone = "success" | "error" | "info";
export interface ToastMessage { id: number; message: string; tone: ToastTone }

const state = reactive<{ items: ToastMessage[] }>({ items: [] });
let seq = 0;

export function toast(message: string, tone: ToastTone = "info", duration = 2600) {
  const id = ++seq;
  state.items.push({ id, message, tone });
  window.setTimeout(() => dismiss(id), duration);
  return id;
}

export function dismiss(id: number) {
  const index = state.items.findIndex(item => item.id === id);
  if (index >= 0) state.items.splice(index, 1);
}

export function useToasts() {
  return readonly(state.items);
}

export function useToast() {
  return { show: toast, message: readonly(state.items) };
}
